// @ts-nocheck
import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import SearchIcon from '@mui/icons-material/Search';
import InputAdornment from "@mui/material/InputAdornment";
import Joi from 'joi';
import { RUTA_API_ALIAS } from "../../Contantes/Constantes";
import { setupInterceptorsTo } from "../../Componentes/API/AxiosBuilder";
import { useBody } from "../../Body/state/BodyContext";
import { useAlias } from "../State/AliasContext";
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import Fab from '@mui/material/Fab';
import Tooltip from '@mui/material/Tooltip';
import SinapTheme from "../../styles/SinapTheme";
import AlternateEmailIcon from "@mui/icons-material/AlternateEmail";
import Badge from "@mui/material/Badge";
import makeStyles from '@mui/styles/makeStyles';
import { TextFieldRojo } from "../../App";
import KeyCloak from "../../Auth/Keycloak";
import { AliasForm } from "../AltaAlias";
import { ModalGeneral } from "../../Componentes/ModalGeneral";
import CircularProgress from "@mui/material/CircularProgress";
import { Typography } from "@mui/material";

const schema = Joi.object({
    patron: Joi.string().alphanum().min(1).max(30).required()
});

const BuscadorAlias = (props) => {
    const { patron, setPatron, fetchAlias, loadingAlias } = useAlias();
    const setAliases = props.setAliases;
    const { setMessage, setSuccess, setInfo } = useBody();
    const axiosInstance = setupInterceptorsTo(axios.create());
    const theme = useTheme();
    const [open, setOpen] = useState(false);
    const currentRequestId = useRef(0);
    const matches = useMediaQuery('(min-width:1185px)');

    const handleOpen = () => {
        setOpen(true)
    };

    const onClose = () => {
        setOpen(false)
    }

    const isValid = (patron) => {
        const { error } = schema.validate({ patron: patron });

        return error === undefined;
    };

    const buscar = async (p) => {
        currentRequestId.current++;
        await fetchAlias(p);
    };

    useEffect(() => {
        const debounceTimeout = setTimeout(() => {
            if (isValid(patron)) buscar(patron);
        }, 800);
        return () => clearTimeout(debounceTimeout);
    }, [patron]);

    const handleChange = (e) => {
        let patronBuscado = e.target.value;
        if (patronBuscado.length < 1) return false;
        if (!isValid(patronBuscado)) {
            e.target.error = true;
            e.target.helperText = "Alguno de los caracteres ingresados es inválido";
            setMessage("Alguno de los caracteres ingresados es inválido");
            return false;
        } else {
            e.target.error = false;
            e.target.helperText = "Ingrese un nombre o dirección de alias, o un email de destinatario.";
            setPatron(patronBuscado);
        }
    };

    return (
        <>
            <div>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
                    <Typography
                        my={"40px"}
                        fontSize={matches ? "30px" : "28px"}
                    >
                        Buscador de Alias
                    </Typography>
                    {KeyCloak.hasRole(["ROLE_CREAR_ALIAS"]) ?
                        <Tooltip title="Agregar Alias">
                            <Fab
                                sx={{
                                    zIndex: 1,
                                    backgroundColor: SinapTheme.palette.primary.main,
                                    width: { xs: 42, sm: 48, md: 52 },
                                    height: { xs: 42, sm: 48, md: 52 },
                                    '&:hover': {
                                        backgroundColor: SinapTheme.palette.primary.light,
                                    },
                                }}
                                onClick={handleOpen}
                                aria-label="add"
                            >
                                <Badge
                                    badgeContent="+"
                                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                    sx={{
                                        '& .MuiBadge-badge': {
                                            color: "#fefdfa",
                                            fontWeight: "bold",
                                            fontSize: 18,
                                            transform: 'scale(1) translate(-42%, 42%)',
                                        }
                                    }}
                                >
                                    <AlternateEmailIcon sx={{ color: "#fefdfa", fontSize: { xs: 20, sm: 24, md: 26 } }} />
                                </Badge>
                            </Fab>
                        </Tooltip>
                        : null}
                </div>
                <TextFieldRojo
                    fullWidth
                    sx={{
                        marginY: "10px"
                    }}
                    id="buscador"
                    label="Mail"
                    onChange={handleChange}
                    variant="outlined"
                    helperText="Ingrese un nombre, dirección de alias o email de destinatario."
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <SearchIcon />
                            </InputAdornment>
                        ),
                    }}
                />
            </div>
            <ModalGeneral
                titulo="Agregar Alias"
                Contenido={<AliasForm alias={null} method="POST" onClose={onClose} />}
                open={open}
                handleOpen={handleOpen}
                onClose={onClose}
            />
        </>
    );
}

export default BuscadorAlias;